import * as tslib_1 from "tslib";
// Core components
import { OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatInput } from '@angular/material';
// Third party components
import { FieldType } from '@ngx-formly/material';
import { take } from 'rxjs/operators';
// Custom components
import { ManualAddressDialogComponent } from 'src/app/shared/components/dialogs/manual-address-dialog/manual-address-dialog.component';
import { HelperService } from 'src/app/shared/services/helper.service';
var AddressTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AddressTypeComponent, _super);
    function AddressTypeComponent(helperService, dialog) {
        var _this = _super.call(this) || this;
        _this.helperService = helperService;
        _this.dialog = dialog;
        _this.formControl2 = new FormControl();
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    AddressTypeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.to.disabled) {
            this.formControl2.disable();
        }
        if (this.formControl.value) {
            this.formControl2.setValue(this.helperService.getFormattedAddress(this.formControl.value));
        }
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    AddressTypeComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
    * Listen for @Input changes
    *
    * @since 1.0.0
    */
    AddressTypeComponent.prototype.ngOnChanges = function () {
        if (this.formControl.value) {
            this.formControl2.setValue(this.helperService.getFormattedAddress(this.formControl.value));
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AddressTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
    };
    /**
     * Open a new dialog used to let user manually fill address
     * data and save that data
     *
     * @since 1.0.0
     */
    AddressTypeComponent.prototype.openManualAddressDialog = function (googleRes) {
        var _this = this;
        var addressData = {};
        if (googleRes) {
            addressData.route = googleRes.route;
            addressData.streetNumber = googleRes.streetNumber;
            addressData.postalCode = googleRes.postalCode;
            addressData.city = googleRes.city;
            addressData.administrativeArea1 = googleRes.administrativeArea1;
            addressData.administrativeArea2 = googleRes.administrativeArea2;
            addressData.administrativeArea3 = googleRes.administrativeArea3;
            addressData.countryCodeTwo = googleRes.countryCodeTwo;
            addressData.latitude = googleRes.latitude;
            addressData.longitude = googleRes.longitude;
        }
        // @todo completare
        var dialogRef = this.dialog.open(ManualAddressDialogComponent, {
            data: tslib_1.__assign({}, addressData, { required: this.to.required }),
            width: '600px',
            autoFocus: false,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            if (typeof res2 !== 'undefined') {
                var formattedAddress = _this.helperService.getFormattedAddress(res2);
                _this.formControl.setValue(res2);
                _this.formControl2.setValue(formattedAddress);
            }
        });
    };
    /**
     * Once formControl2 has been clicked just make the label
     * float
     *
     * @todo this cause label to float even once user click in
     * some other field and it's not good. Would be nice to find
     * a way to make label disappear once user defocus the input
     *
     * @since 1.0.0
     */
    AddressTypeComponent.prototype.onClick = function () {
        this.formField.floatLabel = 'always';
        this.openManualAddressDialog(this.formControl.value);
    };
    return AddressTypeComponent;
}(FieldType));
export { AddressTypeComponent };
